import {
  cellReturnCateg,
  cellReturnData,
  columnComponent,
} from './tableHelper';

export type ColumnConfig = {
  header: string;
  accessorKey: string;
  id?: string;
  size?: number;
  enableSorting?: boolean;
  cellReturn?: any;
};

// Function to create a column component
export const createColumn = ({
  header,
  accessorKey,
  id,
  size,
  enableSorting,
  cellReturn,
}: ColumnConfig) => {
  return columnComponent(
    header,
    {
      accessorKey,
      id,
      size,
      enableSorting,
    },
    cellReturn?.name === 'categ'
      ? cellReturnCateg(cellReturn.value)
      : cellReturn?.name === 'data'
      ? cellReturnData(cellReturn.key, cellReturn.value)
      : cellReturn?.value
  );
};
